import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ApiService } from '../service/api.service';
import { PoMultiselectOption, PoSelectOption } from '@po-ui/ng-components';
import { TokenService } from '../service/token.service';
import { Router } from '@angular/router';
import { FilterService } from './filter.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css'],
})
export class FilterComponent implements OnInit {
  @Input() filterState: any;
  @Output() filterClick = new EventEmitter();
  objFilter: object = {};
  toDay!: string | Date;
  maxDate!: string | Date;
  minDate!: string | Date;
  minDateNoventa!: string | Date;
  format!: string;
  sellerSelected!: any;
  typeClassificationSelected!: number;
  typeClassificationLocationSelected!: number;
  brachList: Array<PoSelectOption> = [];
  sellerList: Array<PoSelectOption> = [];
  typeClassificationList: Array<PoSelectOption> = [];
  typeClassificationLocationList: Array<PoSelectOption> = [];
  branchSelected: Array<any> = [];
  branchSelectedManufacturing: Array<any> = [];
  dateFirst!: any;
  token!: any;
  routerMoment!: any;
  validateFields: Array<string> = ['state'];
  show: boolean = true;
  filterInit!: any;
  dateInvalid!: boolean;
  branchsStartFilter: any = []
  branchsParamFilter!: any;
  flagMinDate: boolean = false;

  _fieldTypeClassification: any = {
    items: [],
  };

  options: Array<PoMultiselectOption> = [
    { value: 0, label: 'Avulsa' },
    { value: 1, label: 'Principal' },
    { value: 2, label: 'Componente' },
    { value: 3, label: 'Principal/Componente' },
  ];
  multiselect: Array<string> = [];

  constructor(
    private api: ApiService,
    private tokenService: TokenService,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    private filterService: FilterService
  ) {
    this.routerMoment = this.router;
  }

  async ngOnInit() {
    let date = new Date();
    this.toDay = new Date();
    this.maxDate = date;
    if (this.routerMoment.url === '/home/salers') {
      this.minDateNoventa = moment(this.toDay).subtract(60, 'months').format("YYYY-MM-DD");
      this.minDate = moment(this.toDay).subtract(1, 'months').format("YYYY-MM-DD");
    } else {
      this.minDateNoventa = moment(this.toDay).subtract(3, 'months').format("YYYY-MM-DD");
      this.minDate = date;
    }
    this.token = this.tokenService.getToken();
    this.getBranchs();

    this.filterInit = this.filterService.onLoadLocalsStore();
    if (this.filterInit != '') {
      this.multiselect = this.filterInit.typeProduct;
    }
    this.changeDetector.markForCheck();
  }

  recoverSellersList() {
    this.sellerList = [];
    this.getSellerList().subscribe((data) => {
      data.dataRow.map((el: any) => {
        this.sellerList = [
          ...this.sellerList,
          { label: el.seller_name, value: el.seller_code },
        ];
      });
    });
  }

  recoverBranchSellersList(item: boolean) {
    this.brachList = [];
    this.getBranchSellerList().subscribe((data) => {
      data.dataRow.map((el: any) => {
        this.brachList = [
          ...this.brachList,
          { label: el.code + ' - ' + el.tradingName, value: el.code }
        ]
      });
      if (this.branchsParamFilter && !item) {
        const hasCommonItem = this.brachList.some((item1: any) =>
          this.branchsParamFilter.some((item2: any) => item2 === item1.value)
        );
        hasCommonItem
          ? this.branchSelected = this.branchsParamFilter
          : this.branchSelected = [this.brachList[0]?.value];
      } else if (!item) {
        this.branchSelected = [this.brachList[0]?.value]
      }
    });
  }

  getSellerList() {
    return this.api.postSellersList(this.branchSelected);
  }

  getBranchSellerList() {
    return this.api.getBranchSeller();
  }

  getBranchsList() {
    return this.api.getBranchList();
  }

  async getBranchs() {
    this.paramBranchSelect().subscribe(dataParam => {
      this.branchsParamFilter = dataParam.items[0].value.split(';').map(Number)
    });

    this.getBranchsList().subscribe((data) => {
      data.items.map((el: any) => {
        this.branchsStartFilter.push(el.code);
        this.brachList = [
          ...this.brachList,
          { label: el.code + ' - ' + el.personName, value: el.code },
        ];
      });

      // Salva todas as empresas disponíveis no localStorage
      localStorage.setItem('filterAllBranchs', JSON.stringify(this.branchsStartFilter));

      let objectJsonBranch = localStorage.getItem('filterInfoBranchs');
      this.branchSelected = objectJsonBranch ? JSON.parse(objectJsonBranch) : (this.branchsParamFilter ? this.branchsParamFilter : this.branchsStartFilter);
      let objectJsonMinDate = localStorage.getItem('filterInfoMinDate');
      this.minDate = objectJsonMinDate ? JSON.parse(objectJsonMinDate) : this.minDate;
      let objectJsonMaxDate = localStorage.getItem('filterInfoMaxDate');
      this.maxDate = objectJsonMaxDate ? JSON.parse(objectJsonMaxDate) : this.maxDate;
      let objectJsonSellers: any = localStorage.getItem('filterInfoSellers');
      let arraSellers = JSON.parse(objectJsonSellers);

      this.sellerSelected = objectJsonSellers ? arraSellers[0] : null;

      this.filterInit != ''
        ? this.branchSelectedManufacturing = this.filterInit.branchStore
        : this.branchSelectedManufacturing = [this.brachList[0]?.value];

      this.routerMoment.url === '/home/salers'
        ? this.recoverBranchSellersList(false)
        : this.recoverSellersList();

      this.changeDetector.markForCheck();

      this.routerMoment.url === '/home/manufacturing'
        ? this.getClassifications()
        : this.onFilter();
    });
  }

  paramBranchSelect(): Observable<any> {
    return this.api.getParam('DS_LST_EMP_MOPFC001');
  }

  recoverBranchSelected(item: any) {
    this.branchSelected = item;
  }

  recoverBranchSelectedManufacturing(item: any) {
    this.branchSelectedManufacturing = item;
  }

  recoverSellerSelected(item: any) {
    this.sellerSelected = item;
  }
  recoverTypeClassificationSelected(item: number) {
    this.typeClassificationSelected = item;
  }

  recoverTypeClassificationLocationSelected(item: any) {
    this.typeClassificationLocationSelected = item;
  }

  onFilter() {
    this.show = true;
    setTimeout(() => {
      let classDescription = '';
      let classLocDescription = '';
      let branchItem =
        this.routerMoment.url === '/home/manufacturing'
          ? this.branchSelectedManufacturing
          : this.branchSelected;
      if (this.routerMoment.url === '/home/manufacturing') {
        if (this.typeClassificationSelected != null)
          classDescription = this.typeClassificationList.filter(
            (c) => c.value == this.typeClassificationSelected
          )[0].label;

        if (this.typeClassificationLocationSelected != null)
          classLocDescription = this.typeClassificationLocationList.filter(
            (c) => c.value == this.typeClassificationLocationSelected
          )[0].label;
      }

      if (this.minDate === "")
        this.minDate = moment(this.toDay).format("YYYY-MM-DD");
      if (this.maxDate === "")
        this.maxDate = moment(this.toDay).format("YYYY-MM-DD");
      this.changeMinDateNoventa()

      this.dateInvalid = false;
      if (this.minDate < this.minDateNoventa)
        this.dateInvalid = true;

      this.objFilter = {
        dataMin: this.minDate,
        dataMax: this.maxDate,
        branch: branchItem ? branchItem : [1],
        sellers: this.sellerSelected ? [this.sellerSelected] : [],
        typeClassification: this.typeClassificationSelected !== null ?
          (this.typeClassificationSelected === 0 ? [0] : [this.typeClassificationSelected])
          : [],
        typeProduct: this.multiselect ? this.multiselect : [],
        typeClassificationLocation: this.typeClassificationLocationSelected
          ? this.typeClassificationLocationSelected
          : [],
        typeClassificationDescription: classDescription,
        typeClassificationLocationDescription: classLocDescription,
        dateInvalid: this.dateInvalid,
      };

      if (this.typeClassificationSelected !== undefined && this.typeClassificationLocationSelected !== undefined && this.branchSelectedManufacturing !== undefined) {
        this.filterState = {
          branchStore: this.branchSelectedManufacturing,
          classificationType: this.typeClassificationSelected,
          classificationTypeLocation: this.typeClassificationLocationSelected,
          typeProduct: this.multiselect,
        };

        this.filterService.onSaveLocalsStore(this.filterState);
      }

      this.filterClick.emit(this.objFilter);
      this.show = false;
    }, 2000);
  }

  async onFilterRefresh() {
    let branchsParamFilter: any;
    let branchsAllSelect: any = [];
    this.minDate = moment(new Date()).format("YYYY-MM-DD");
    this.maxDate = moment(new Date()).format("YYYY-MM-DD");

    this.paramBranchSelect().subscribe(dataParam => {
      branchsParamFilter = dataParam.items[0].value.split(';').map(Number)

      this.brachList.filter((el: any) => {
        branchsAllSelect.push(el.value)
      })

      this.objFilter = {
        dataMin: this.minDate,
        dataMax: this.maxDate,
        branch: branchsParamFilter ? branchsParamFilter : branchsAllSelect,
        sellers: [],
      };

      branchsParamFilter ? this.branchSelected = branchsParamFilter : this.branchSelected = branchsAllSelect

      this.filterClick.emit(this.objFilter);
    });
  }

  changeMinDateNoventa() {
    if (this.maxDate === "")
      this.maxDate = moment(this.toDay).format("YYYY-MM-DD");

    if (this.routerMoment.url === '/home/salers' && !this.flagMinDate) {
      const firstDayOfMonth = new Date();
      firstDayOfMonth.setDate(1);
      firstDayOfMonth.setHours(0, 0, 0, 0);
      const formattedDate = firstDayOfMonth.toISOString().split('T')[0];
      this.minDate = formattedDate;
      this.flagMinDate = true;
    }

    this.routerMoment.url !== '/home/salers'
      ? this.minDateNoventa = moment(this.maxDate).subtract(3, 'months').format("YYYY-MM-DD")
      : this.minDateNoventa = moment(this.maxDate).subtract(12, 'months').format("YYYY-MM-DD")
  }

  validateDateMin() {
    if (this.minDate === undefined)
      this.minDate = this.toDay;
  }

  getTypeClassification() {
    return this.api.getTypeClassification();
  }

  getTypeClassificationLocation() {
    return this.api.getClassificationLocationList();
  }

  getTypeClassificationLocationSubscribe() {
    this.getTypeClassificationLocation().subscribe(data => {
      try {
        for (let item of data.items) {
          this.typeClassificationLocationList = [
            ...this.typeClassificationLocationList,
            { label: item.description, value: item.code },
          ];
        }
        if (this.filterInit != '') {
          this.typeClassificationLocationSelected =
            this.filterInit.classificationTypeLocation;
        }
        this.onFilter();
        this.changeDetector.markForCheck();
      } catch (error) { }
    });
  }

  getClassifications() {
    this.getTypeClassification().subscribe(data => {
      try {
        for (let item of data.items) {
          this.typeClassificationList = [
            ...this.typeClassificationList,
            {
              label: item.description,
              value: item.code,
            },
          ];
        }
        if (this.filterInit != '') {
          this.typeClassificationSelected = this.filterInit.classificationType;
        }
        this.changeDetector.markForCheck();

        this.getTypeClassificationLocationSubscribe();
      } catch (error) { }
    });
  }
}
